// Data utilities - ab sirf helper functions hain
// Actual data API se aata hai

export const uid = () => Math.random().toString(36).slice(2, 9);
export const today = () => new Date().toISOString().split("T")[0];

export function loadUser() {
  try {
    const u = localStorage.getItem("uni_user_v3");
    return u ? JSON.parse(u) : null;
  } catch { return null; }
}

export function saveUser(u) {
  try { localStorage.setItem("uni_user_v3", JSON.stringify(u)); } catch (e) {}
}

export function clearUser() {
  try {
    localStorage.removeItem("uni_user_v3");
    localStorage.removeItem("uni_token");
  } catch (e) {}
}

export function getToken() {
  return localStorage.getItem("uni_token") || null;
}

export function saveToken(t) {
  localStorage.setItem("uni_token", t);
}

// Backward compatibility - ab kuch nahi karta
export const saveData = () => {};

// Course access logic
export function getCourseAccess(studentId, programId, allCourses, examResults) {
  const courses = allCourses.filter(c => c.program_id === programId || c.programId === programId);
  const general = courses.filter(c => c.level === "general");
  const core = courses.filter(c => c.level === "core");
  const specialist = courses.filter(c => c.level === "specialist");

  const isExamPassed = (courseId) => {
    const result = examResults.find(r =>
      (r.exam_course_id === courseId || r.courseId === courseId) && r.final_score >= 60
    );
    return !!result;
  };

  const generalComplete = general.length > 0 && general.every(c => isExamPassed(c.id));
  const coreComplete = generalComplete && core.length > 0 && core.every(c => isExamPassed(c.id));

  return {
    general:    { courses: general,    unlocked: true,           complete: generalComplete },
    core:       { courses: core,       unlocked: generalComplete, complete: coreComplete },
    specialist: { courses: specialist, unlocked: coreComplete,   complete: false },
    isExamPassed,
  };
}